import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../services/auth";
import { Helmet } from "react-helmet";
import Loader from "../shared/Loader";
import {
  getItems,
  deleteItem,
  deleteService,
  deleteCategory,
  deleteSubcategory,
  updateMenu,
  getMenu,
} from "../services/menu";
import styles from "../css/updateMenu.module.css";
import AppContext from "../contexts/appContext";
import { getSimpleServicePages } from "../services/getServicePages";

function UpdateMenu() {
  const { menu, setMenu } = useContext(AppContext);

  const [user, setUser] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [selectedService, setSelectedService] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedSubCat, setSelectedSubCat] = useState();
  const [selectMenuItem, setSelectMenuItem] = useState();
  const [serviceItem, setServiceItem] = useState();
  const [servicePages, setServicePages] = useState();
  const [serviceDynamicContentId, setServiceDynamicContentId] = useState();
  const [items, setItems] = useState();
  const [serviceName, setServiceName] = useState();
  const [catName, setCatName] = useState();
  const [subCatName, setSubCatName] = useState();
  const [subCatLinkTo, setSubCatLinkTo] = useState();
  const [subCatNameOfService, setSubCatNameOfService] = useState();
  const [subCatParseImage, setSubCatParseImage] = useState(false);
  const [subCatPlaceholderText, setSubCatPlaceholderText] = useState();
  const [menuItemName, setMenuItemName] = useState();
  const [menuItemQuantity, setMenuItemQuantity] = useState();
  const [menuItemPrice, setMenuItemPrice] = useState();
  const [menuItemPromotion, setMenuItemPromotion] = useState(false);
  const [menuItemDiscount, setMenuItemDiscount] = useState(false);
  const [menuItemDiscountPrice, setMenuItemDiscountPrice] = useState();
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const isAdmin = auth().isAdmin();
  const token = auth().getToken();
  const navigate = useNavigate();

  let PageSize = 200;

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  useEffect(() => {
    if (!isAdmin) {
      navigate("/");
    }
    const data = auth().getUser();
    if (data && !user) {
      setUser(data);
    }
    const readMenu = async () => {
      setIsLoading(true);
      try {
        const response = await getMenu();
        if (response.status === 200) {
          setMenu(response.data);
          setHasError(false);
          isLoading(false);
        }
        if (response.status === 400) {
          //TODO error handle
          setHasError(true);
        }
        return response.data;
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };
    readMenu();
    readServices();
    readServicePage();
  }, [refresh]);

  const setChecked = (e) => {
    e.name === "menuItemDiscount"
      ? setMenuItemDiscount(!menuItemDiscount)
      : setMenuItemPromotion(!menuItemPromotion);
  };

  const readServices = async () => {
    try {
      const response = await getItems(PageSize, config);
      setItems(response.data.data);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };
  const readServicePage = async () => {
    getSimpleServicePages(1, PageSize, "", config)
      .then((response) => {
        setServicePages(response.data);
        setHasError(false);
      })
      .catch((error) => {
        setHasError(true);
        setError("Invalid fetching, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const addService = () => {
    if (serviceName) {
      const newMenu = menu;
      newMenu?.push({
        name: serviceName,
        category: [],
      });
      setMenu(newMenu);
      setServiceName("");
    }
  };

  const addCategory = () => {
    if (catName) {
      const newMenu = menu;
      const selectedCatIndex = newMenu.findIndex((item, i) => i == selectedService);
      newMenu[selectedCatIndex]?.category?.push({
        name: catName,
        subcategory: [],
      });
      setMenu(newMenu);
      setCatName("");
    }
  };

  const addSubCategory = () => {
    if (subCatName && serviceItem) {
      const newMenu = menu;
      newMenu
        .find((item, i) => i == selectedService)
        ?.category?.find((cat, i) => i == selectedCategory)
        ?.subcategory?.push({
          name: subCatName,
          linkTo: subCatLinkTo,
          nameOfService: subCatNameOfService,
          parseImage: String(subCatParseImage).toLowerCase() === "true",
          placeholderText: subCatPlaceholderText,
          itemId: serviceItem,
          menuItem: [],
          serviceDynamicContentId: serviceDynamicContentId,
        });
      setMenu(newMenu);
      setSubCatName("");
      setSubCatLinkTo("");
      setSubCatNameOfService("");
      setSubCatParseImage(false);
      setSubCatPlaceholderText("");
    }
  };

  const addMenuItem = () => {
    if (menuItemName) {
      const newMenu = menu;

      newMenu
        .find((item, i) => i == selectedService)
        ?.category?.find((cat, i) => i == selectedCategory)
        ?.subcategory?.find((subCat, i) => i == selectedSubCat)
        ?.menuItem?.push({
          name: menuItemName,
          discount: String(menuItemDiscount).toLowerCase() === "true",
          discountPrice: parseFloat(menuItemDiscountPrice) ? parseFloat(menuItemDiscountPrice) : 0,
          promotion: String(menuItemPromotion).toLowerCase() === "true",
          quantity: Number.isInteger(parseInt(menuItemQuantity)) ? parseInt(menuItemQuantity) : 0,
          price: parseFloat(menuItemPrice) ? parseFloat(menuItemPrice) : 0,
        });

      setMenu(newMenu);
      setMenuItemName("");
    }
    cancelMenuItem();
  };

  const editMenuItem = () => {
    if (menuItemName) {
      const newMenu = menu;
      const oldMenuItem = newMenu
        .find((item, i) => i == selectedService)
        ?.category?.find((cat, i) => i == selectedCategory)
        ?.subcategory?.find((subCat, i) => i == selectedSubCat)
        ?.menuItem.find((cat, i) => i == selectMenuItem);
      newMenu
        .find((item, i) => i == selectedService)
        ?.category?.find((cat, i) => i == selectedCategory)
        ?.subcategory?.find((subCat, i) => i == selectedSubCat)
        ?.menuItem?.splice(selectMenuItem, 1, {
          name: menuItemName,
          discount: String(menuItemDiscount).toLowerCase() === "true",
          discountPrice: parseFloat(menuItemDiscountPrice) ? parseFloat(menuItemDiscountPrice) : 0,
          promotion: String(menuItemPromotion).toLowerCase() === "true",
          quantity: Number.isInteger(parseInt(menuItemQuantity)) ? parseInt(menuItemQuantity) : 0,
          price: parseFloat(menuItemPrice) ? parseFloat(menuItemPrice) : 0,
          id: oldMenuItem.id,
        });
      setMenu(newMenu);
      cancelMenuItem();
    }
  };

  const cancelMenuItem = () => {
    setSelectMenuItem("");
    setMenuItemName("");
    setMenuItemQuantity("");
    setMenuItemPrice("");
    setMenuItemPromotion(false);
    setMenuItemDiscount(false);
    setMenuItemDiscountPrice("");
  };

  const fillMenuItem = (value) => {
    setSelectMenuItem(value);
    const selectedItem = menu
      .find((item, i) => i == selectedService)
      ?.category?.find((cat, i) => i == selectedCategory)
      ?.subcategory?.find((subCat, i) => i == selectedSubCat)
      ?.menuItem?.find((subCat, i) => i == value);
    setMenuItemName(selectedItem?.name);
    setMenuItemQuantity(selectedItem?.quantity);
    setMenuItemPrice(selectedItem?.price);
    setMenuItemPromotion(selectedItem?.promotion);
    setMenuItemDiscount(selectedItem?.discount);
    setMenuItemDiscountPrice(selectedItem?.price);
  };

  const fillSubCategory = (value) => {
    setSelectedSubCat(value);
    const selectedServiceItem = menu
      .find((item, i) => i == selectedService)
      ?.category?.find((cat, i) => i == selectedCategory)
      ?.subcategory?.find((subCat, i) => i == value);
    setServiceItem(selectedServiceItem.itemId);
    setServiceDynamicContentId(selectedServiceItem.serviceDynamicContentId);
    setSubCatName(selectedServiceItem.name);
    setSubCatLinkTo(selectedServiceItem.linkTo);
    setSubCatNameOfService(selectedServiceItem.nameOfService);
    setSubCatParseImage(selectedServiceItem.parseImage);
    setSubCatPlaceholderText(selectedServiceItem.placeholderText);
  };

  const fillCategory = (value) => {
    setSelectedCategory(value);
    const selectedCategory = menu
      .find((item, i) => i == selectedService)
      ?.category?.find((cat, i) => i == value);
    setCatName(selectedCategory.name);
    cancelEditSubCategory();
  };

  const fillService = (value) => {
    setSelectedService(value);
    const selectedService = menu.find((cat, i) => i == value);
    setServiceName(selectedService.name);
    cancelEditCategory();
  };

  const editSubCategory = (value) => {
    const newMenu = menu;
    const oldMenu = newMenu
      .find((item, i) => i == selectedService)
      ?.category?.find((cat, i) => i == selectedCategory)
      ?.subcategory?.find((subCat, i) => i == selectedSubCat);
    const newItemId = serviceItem != oldMenu.itemId ? serviceItem : oldMenu.itemId;
    const newServiceDynamicContentId =
      serviceDynamicContentId != oldMenu.serviceDynamicContentId
        ? serviceDynamicContentId
        : oldMenu.serviceDynamicContentId;

    newMenu
      .find((item, i) => i == selectedService)
      ?.category?.find((cat, i) => i == selectedCategory)
      ?.subcategory?.splice(selectedSubCat, 1, {
        name: subCatName,
        linkTo: subCatLinkTo,
        nameOfService: subCatNameOfService,
        parseImage: String(subCatParseImage).toLowerCase() === "true",
        placeholderText: subCatPlaceholderText,
        menuItem: oldMenu.menuItem,
        itemId: newItemId,
        id: oldMenu.id,
        category: oldMenu.categoryId,
        serviceDynamicContentId: newServiceDynamicContentId,
      });
    setMenu(newMenu);
    cancelEditSubCategory();
  };

  const updateSubCatParseImage = (e) => {
    setSubCatParseImage(e.target.checked);
  };

  const editCategory = () => {
    const newMenu = menu;
    const selectedOldCategory = menu
      .find((item, i) => i == selectedService)
      ?.category?.find((cat, i) => i == selectedCategory);
    newMenu
      .find((item, i) => i == selectedService)
      ?.category?.splice(selectedCategory, 1, {
        name: catName,
        subcategory: selectedOldCategory.subcategory,
        id: selectedOldCategory.id,
        serviceMenuId: selectedOldCategory.serviceMenuId,
      });
    setMenu(newMenu);
    cancelEditCategory();
  };

  const editService = () => {
    const newMenu = menu;
    const selectedOldService = menu.find((cat, i) => i == selectedService);
    newMenu.splice(selectedService, 1, {
      name: serviceName,
      category: selectedOldService.category,
      id: selectedOldService.id,
    });
    setMenu(newMenu);
    cancelEditCategory();
    setSelectedService("");
  };

  const cancelEditSubCategory = () => {
    setServiceItem("");
    setSelectedSubCat("");
    setSubCatName("");
    setSubCatLinkTo("");
    setSubCatNameOfService("");
    setSubCatParseImage("");
    setSubCatPlaceholderText("");
    cancelMenuItem();
    setServiceDynamicContentId("");
  };

  const cancelEditCategory = () => {
    cancelEditSubCategory();
    setCatName("");
    setSelectedCategory("");
  };

  const cancelEditService = () => {
    cancelEditCategory();
    setServiceName("");
    setSelectedService("");
  };

  const removeMenuItem = (value) => {
    return deleteItem(value, config)
      .then((response) => {
        if (response.status === 200) {
          setRefresh(!refresh);
        }
        if (response.status === 400) {
          //TODO error handle
        }
        return response.data;
      })
      .catch((error) => {
        setHasError(true);
        setSuccess(false);
        setError("Internal error, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const removeSubCategory = (value) => {
    return deleteSubcategory(value, config)
      .then((response) => {
        if (response.status === 200) {
          cancelEditSubCategory("");
          setServiceName("");
          setSelectedService("");
          setRefresh(!refresh);
        }
        if (response.status === 400) {
          //TODO error handle
        }
        return response.data;
      })
      .catch((error) => {
        setHasError(true);
        setSuccess(false);
        setError("Internal error, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const removeCategory = (value) => {
    return deleteCategory(value, config)
      .then((response) => {
        if (response.status === 200) {
          cancelEditCategory("");
          setRefresh(!refresh);
          setSuccess(true);
        }
        if (response.status === 400) {
          //TODO error handl
        }
        return response.data;
      })
      .catch((error) => {
        setHasError(true);
        setSuccess(false);
        setError("Internal error, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const removeService = (value) => {
    return deleteService(value, config)
      .then((response) => {
        if (response.status === 200) {
          cancelEditService("");
          setRefresh(!refresh);
          setSuccess(true);
        }
        if (response.status === 400) {
        }
        return response.data;
      })
      .catch((error) => {
        setHasError(true);
        setSuccess(false);
        setError("Internal error, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const updateMenu1 = () => {
    return updateMenu(menu, config)
      .then((response) => {
        if (response.status === 200) {
          setMenu(response.data);
          setRefresh(!refresh);
          setSuccess(true);
        }
        if (response.status === 400) {
          //TODO error handle
        }
        return response.data;
      })
      .catch((error) => {
        setHasError(true);
        setSuccess(false);
        setError("Internal error, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="flex flex-col mx-10">
      <Helmet>
        <title>Dailysocialboost | Menu</title>
      </Helmet>
      <h2 className="mx-28 text-xl self-center lg:self-start font-bold my-10">Update Menu</h2>
      <div className="flex flex-col lg:flex-row  min-h-full justify-center items-center lg:items-start lg:gap-2 gap-10 flex-shrink-0">
        <div className="flex flex-col w-64 h-full">
          {menu
            ?.sort((a, b) => a.id - b.id)
            .map((service, index) => (
              <div
                className={`dropdown inline-block relative ${
                  selectedService == index ? " px-2 text-pink-500" : ""
                }`}
                id={service.id}
                key={`service-${service}-serviceIndex-${index}`}
              >
                <button className="font-semibold py-2 px-2 inline-flex items-center uppercase hover:text-pink-350 transition-all">
                  <span id={index} onClick={(e) => fillService(e.target.id)}>
                    {service.name} &#x23f5;
                  </span>
                </button>
                <button className="font-semibold py-2 px-3 inline-flex items-center uppercase text-red-600 rounded-3xl hover:text-white hover:bg-red-600 hover:opacity-90 transition-all">
                  <span id={index} onClick={(e) => removeService(service.id)}>
                    x
                  </span>
                </button>
              </div>
            ))}
          <div className="flex flex-col mt-auto">
            {!selectedService ? (
              <button
                className="my-5 px-3 py-2 w-42 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                onClick={addService}
              >
                Add Service
              </button>
            ) : (
              <div className="flex flex-row">
                <button
                  className="my-5 px-3 py-2 w-42 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                  onClick={editService}
                >
                  Edit Service
                </button>
                <button
                  className="font-semibold my-5 mx-2 px-3 py-2 w-42 self-start uppercase text-red-600 rounded-3xl hover:text-white hover:bg-red-600 hover:opacity-90 transition-all"
                  onClick={cancelEditService}
                >
                  x
                </button>
              </div>
            )}
            <input
              className="transition ease-in-out hover:border-b-pink-500  hover:border-b-2 h-8 w-full bg-white outline-0 border border-transparent border-b-gray-600"
              onChange={(e) => setServiceName(e.target.value)}
              type="text"
              value={serviceName}
              name="serviceName"
              id="serviceName"
              required
            />
          </div>
        </div>
        <div className="flex flex-col w-64 h-full flex-nowrap">
          {menu
            ?.find((item, i) => i == selectedService)
            ?.category?.sort((a, b) => a.id - b.id)
            .map((category, index) => {
              return (
                <div
                  className={`dropdown inline-block relative ${
                    selectedCategory == index ? " px-2 text-pink-500" : ""
                  }`}
                  key={`catIndex-${category.name}-${index}+${Math.random()}`}
                >
                  <button className="font-semibold py-2 px-2 inline-flex items-center uppercase hover:text-pink-350 transition-all">
                    <span id={index} onClick={(e) => fillCategory(e.target.id)}>
                      {category.name} &#x23f5;
                    </span>
                  </button>
                  <button className="font-semibold py-2 px-3 inline-flex items-center uppercase text-red-600 rounded-3xl hover:text-white hover:bg-red-600 hover:opacity-90 transition-all">
                    <span id={index} onClick={(e) => removeCategory(category.id)}>
                      x
                    </span>
                  </button>
                </div>
              );
            })}
          <div className="flex flex-col mt-auto">
            {!selectedCategory ? (
              <button
                className="my-5 px-3 py-2 w-42 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                onClick={addCategory}
              >
                Add Category
              </button>
            ) : (
              <div className="flex flex-row">
                <button
                  className="my-5 px-3 py-2 w-42 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                  onClick={editCategory}
                >
                  Edit Category
                </button>
                <button
                  className="font-semibold my-5 mx-2 px-3 py-2 w-42 self-start uppercase text-red-600 rounded-3xl hover:text-white hover:bg-red-600 hover:opacity-90 transition-all"
                  onClick={cancelEditCategory}
                >
                  x
                </button>
              </div>
            )}
            <input
              className={`h-8 w-64 ${styles.updateMenuInput}`}
              onChange={(e) => setCatName(e.target.value)}
              type="text"
              value={catName}
              name="catName"
              id="catName"
              required
            />
          </div>
        </div>
        <div className="flex flex-col  w-64 h-full flex-nowrap">
          {menu
            ?.find((item, i) => i == selectedService)
            ?.category?.find((cat, i) => i == selectedCategory)
            ?.subcategory?.sort((a, b) => a.id - b.id)
            .map((subCat, index) => (
              <div
                className={`dropdown inline-block relative ${
                  selectedSubCat == index ? " px-2 text-pink-500" : ""
                }`}
                key={`subCatIndex-${index}+${Math.random()}`}
              >
                <button className="font-semibold py-2 px-2 inline-flex items-center uppercase hover:text-pink-350 transition-all">
                  <span id={index} onClick={(e) => fillSubCategory(e.target.id)}>
                    {subCat?.name} &#x23f5;
                  </span>
                </button>
                <button className="font-semibold py-2 px-3 inline-flex items-center uppercase text-red-600 rounded-3xl hover:text-white hover:bg-red-600 hover:opacity-90 transition-all">
                  <span id={index} onClick={(e) => removeSubCategory(subCat.id)}>
                    x
                  </span>
                </button>
              </div>
            ))}
          <div className="flex flex-col mt-auto">
            {!selectedSubCat ? (
              <button
                className="my-5 px-3 py-2 w-42 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                onClick={addSubCategory}
              >
                Add SubCategory
              </button>
            ) : (
              <div className="flex flex-row">
                <button
                  className="my-5 px-3 py-2 w-42 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                  onClick={editSubCategory}
                >
                  Edit SubCategory
                </button>
                <button
                  className="font-semibold my-5 mx-2 px-3 py-2 w-42 self-start uppercase text-red-600 rounded-3xl hover:text-white hover:bg-red-600 hover:opacity-90 transition-all"
                  onClick={cancelEditSubCategory}
                >
                  x
                </button>
              </div>
            )}
            <input
              className={`h-8 w-64 ${styles.updateMenuInput}`}
              placeholder="Subcategory Name"
              onChange={(e) => setSubCatName(e.target.value)}
              type="text"
              value={subCatName}
              name="subCatName"
              id="subCatName"
              required
            />
            <div className="my-5">
              <select
                className="h-10 w-full px-2 border-transparent rounded-2xl text-purple-650 bg-white"
                value={serviceItem}
                onChange={(e) => setServiceItem(e.target.value)}
                name="serviceItem"
                id="serviceItem"
                required
              >
                {items &&
                  items
                    ?.sort((a, b) => a.id - b.id)
                    .map((service, idx) => (
                      <option id={idx} value={service.id} key={`service-item-${service.id}-${idx}`}>
                        {service.name}
                      </option>
                    ))}
              </select>
            </div>
            <div className="my-5">
              <select
                className="h-10 w-full px-2 border-transparent rounded-2xl text-purple-650 bg-white"
                value={serviceDynamicContentId}
                onChange={(e) => setServiceDynamicContentId(e.target.value)}
                name="serviceDynamicContentId"
                id="serviceDynamicContentId"
                required
              >
                {servicePages &&
                  servicePages
                    ?.sort((a, b) => a.id - b.id)
                    .map((service, idx) => (
                      <option
                        id={`servicePage-` + idx}
                        value={service.id}
                        dangerouslySetInnerHTML={{ __html: service.title }}
                        key={`service-page-item-${service.id}-${idx}`}
                      />
                    ))}
              </select>
            </div>
            <input
              className={`h-8 w-64 ${styles.updateMenuInput}`}
              onChange={(e) => setSubCatLinkTo(e.target.value)}
              type="text"
              value={subCatLinkTo}
              placeholder="Link to service"
              name="subCatLinkTo"
              id="subCatLinkTo"
              required
            />
            <input
              className={`h-8 w-64 ${styles.updateMenuInput}`}
              onChange={(e) => setSubCatNameOfService(e.target.value)}
              type="text"
              value={subCatNameOfService}
              placeholder="Service internal name"
              name="subCatNameOfService"
              id="subCatNameOfService"
              required
            />
            <div className="flex flex-row my-2">
              <label>Use Link</label>
              <input
                className="h-6 mx-6 w-8 bg-gray-100 outline-0 border border-transparent border-b-gray-350"
                onChange={updateSubCatParseImage}
                type="checkbox"
                checked={subCatParseImage}
                name="subCatParseImage"
                id="subCatParseImage"
                required
              />
            </div>
            <input
              className={`h-8 w-64 ${styles.updateMenuInput}`}
              onChange={(e) => setSubCatPlaceholderText(e.target.value)}
              type="text"
              value={subCatPlaceholderText}
              placeholder="Placeholder text"
              name="subCatPlaceholderText"
              id="subCatPlaceholderText"
              required
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row w-2/5 h-full flex-nowrap justify-around">
          <div className="flex flex-col self-center  lg:self-start min-w-fit">
            {menu
              ?.find((item, i) => i == selectedService)
              ?.category?.find((cat, i) => i == selectedCategory)
              ?.subcategory?.find((subCat, i) => i == selectedSubCat)
              ?.menuItem?.sort((a, b) => a.id - b.id)
              .map((menItem, index) => (
                <div
                  className={`dropdown inline-block relative ${
                    selectMenuItem == index ? "px-2 text-pink-500" : ""
                  }`}
                  key={`menuItemIndex-${index}+${Math.random()}`}
                >
                  <button className="font-semibold py-2 px-2 inline-flex items-center uppercase hover:text-pink-350 transition-all">
                    <span id={index} onClick={(e) => fillMenuItem(e.target.id)}>
                      {menItem?.name}
                    </span>
                  </button>
                  <button className="font-semibold py-2 px-3 inline-flex items-center uppercase text-red-600 rounded-3xl hover:text-white hover:bg-red-600 hover:opacity-90 transition-all">
                    <span id={index} idx={menItem.id} onClick={(e) => removeMenuItem(menItem.id)}>
                      x
                    </span>
                  </button>
                </div>
              ))}
          </div>
          <div className="flex flex-col self-center lg:self-start min-w-fit">
            {!selectMenuItem ? (
              <button
                className="my-5 px-3 py-2 w-36 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                onClick={addMenuItem}
              >
                Add Item
              </button>
            ) : (
              <div className="flex flex-row">
                <button
                  className="my-5 px-3 py-2 w-36 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
                  onClick={editMenuItem}
                >
                  Edit Item
                </button>
                <button
                  className="font-semibold my-5 mx-3 px-2 py-2 w-10 self-start uppercase text-red-600 rounded-3xl hover:text-white hover:bg-red-600 hover:opacity-90 transition-all"
                  onClick={cancelMenuItem}
                >
                  x
                </button>
              </div>
            )}
            <input
              className={`h-8 w-64 ${styles.updateMenuInput}`}
              placeholder="Item Name"
              onChange={(e) => setMenuItemName(e.target.value)}
              type="text"
              value={menuItemName}
              name="menuItemName"
              id="menuItemName"
              required
            />
            <input
              className={`h-8 w-64 ${styles.updateMenuInput}`}
              placeholder="Quantity"
              onChange={(e) => setMenuItemQuantity(e.target.value)}
              type="number"
              value={menuItemQuantity}
              name="menuItemQuantity"
              id="menuItemQuantity"
              required
            />
            <input
              className={`h-8 w-64 ${styles.updateMenuInput}`}
              placeholder="Price"
              onChange={(e) => setMenuItemPrice(e.target.value)}
              type="number"
              value={menuItemPrice}
              name="menuItemPrice"
              id="menuItemPrice"
              required
            />
            <label htmlFor="menuItemDiscount">Promotion</label>{" "}
            <input
              className="h-5 w-10 bg-gray-100 outline-0 border border-transparent border-b-gray-350"
              onChange={(e) => setChecked(e.target)}
              type="checkbox"
              checked={menuItemPromotion}
              name="menuItemPromotion"
              id="menuItemPromotion"
              required
            />
            <label htmlFor="menuItemDiscount">Discount</label>{" "}
            <input
              className="h-5 w-10 bg-gray-100 outline-0 border border-transparent border-b-gray-350"
              onChange={(e) => setChecked(e.target)}
              type="checkbox"
              checked={menuItemDiscount}
              name="menuItemDiscount"
              id="menuItemDiscount"
              required
            />
            <input
              className={`h-8 w-64 ${styles.updateMenuInput}`}
              onChange={(e) => setMenuItemDiscountPrice(e.target.value)}
              placeholder="Discount Price"
              type="number"
              value={menuItemDiscountPrice}
              name="menuItemDiscountPrice"
              id="menuItemDiscountPrice"
              required
            />
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-center pt-36 lg:pt-10">
        <button className="my-5 px-3 py-2 w-36 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all">
          <span id={`update-menu-button`} onClick={(e) => updateMenu1(e.target.id)}>
            Update Menu
          </span>
        </button>
      </div>
      <div className="flex flex-row justify-center pt-36 lg:pt-10">
        {isLoading ? (
          <div className="my-5 mx-20 flex flex-row justify-center">
            {" "}
            <Loader styles={"w-12 h-12"}></Loader>{" "}
          </div>
        ) : hasError ? (
          <div
            key={Math.random()}
            className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
            role="alert"
          >
            <svg
              aria-hidden="true"
              className="flex-shrink-0 inline w-5 h-5 mr-3"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              ></path>
            </svg>
            <div>
              <span className="font-medium">Error!</span> {error}
            </div>
          </div>
        ) : null}
        {success ? (
          <div
            className="flex p-4 mb-4 text-sm text-white rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
            role="alert"
          >
            <svg
              aria-hidden="true"
              className="flex-shrink-0 inline w-5 h-5 mr-3"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              ></path>
            </svg>
            <div>
              <span className="font-medium">Success!</span> Sucessfully updated!
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default UpdateMenu;
